




















import { Component, Prop, Vue } from "vue-property-decorator";
import DxPieChart, {
  DxLegend,
  DxSeries,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxExport,
} from "devextreme-vue/pie-chart";

@Component({
  components: {
    DxSeries,
    DxLegend,
    DxTooltip,
    DxLabel,
    DxConnector,
    DxPieChart,
  },
})
export default class PieChart extends Vue {
  @Prop({ type: Array, required: true }) recuentoPorCondicion!: any[];
}
